import Preloader from '../components/Preloader';
import Navigation from '../components/Navigation';
import usePage from '../framework/hooks/usePageHook';
import Footer from '../components/Footer';
import CaseSlider from '../components/case/CaseSlider';
import Brands from '../components/Brands';
import TeamSlider from '../components/team/TeamSlider';
import WhatWeDo from "../components/WhatWeDo";
import About from "../components/About";
import Header from "../components/Header";
import Contact from "../components/Contact";

export default function ContactPage({ page }) {
    // const pageObj = usePage(page.id);

    if (!page) return <Preloader />;

    return (
        <>
            <Navigation page={page} />
            <Contact />
            <TeamSlider />
            <Footer />
        </>
    );
}
